const sortArray = (props:any) => {

  let array_before = props.listx
  let sort_option = props.soption
  let sdir = props.dir
//   console.log("FN sortArray", props)
  var array_sorted = array_before.sort((obj1: any, obj2: any) => {
    if (obj1[sort_option] > obj2[sort_option]) {
      return 1*sdir;
    }
    if (obj1[sort_option] < obj2[sort_option]) {
      return -1*sdir;
    }
    return 0;
  });
//   console.log("[function] sort array", array_before, array_sorted, sort_option, sdir)

  return array_sorted
}

export default sortArray;
